export default {
  mainPageSponsors: [],
  sponsors: [],
  sponsorCount: 0,
  sponsor: {},
  campaigns: [],
  campaignCount: 0,
  filteredCampaigns: [],
  campaign: {}
}